import { Link } from 'react-router-dom';

export const Menu = ({ linklist, path }) => {
  return (
    <div className="sb-row-item">
      <div className="sb-row--linklist-name">
        <p>
          <b>
            <Link to={path}>{linklist.name}</Link>
          </b>
        </p>
      </div>
      <div className="sb-row--linklist-links">
        {linklist.links.length == 0 && <p>No links</p>}
        {linklist.links.length > 0 && (
          <p>{linklist.links.map((link) => link.name).join(', ')}</p>
        )}
      </div>
    </div>
  );
};
